import Backbone from "backbone";
import Parse from "parse";
import _ from "underscore";
import ObservingSite from "../models/ObservingSite";

("use strict");

const User = Parse.User.extend(
	{},
	{
		clientApps: null,

		update: async function (data) {
			const currentUser = this.current();
			if (!currentUser) {
				return;
			}

			try {
				const authenticatedUser = await this.logIn(currentUser.get("username"), data.currentPassword);
				this._updateUserFields(authenticatedUser, data);
				this._updateEmailAndUsername(authenticatedUser, data);
				this._updatePassword(authenticatedUser, data);
				this.updateHomeSite(data, false);

				authenticatedUser.setACL(new Parse.ACL(authenticatedUser));
				await authenticatedUser.save();

				this._updateStripeCustomer(data);
				Backbone.trigger("user:updated", "User profile updated");
			} catch (error) {
				Backbone.trigger("errors:parseReturned", error);
			}
		},

		_updateUserFields: (user, data) => {
			user.set("firstname", data.firstname);
			user.set("lastname", data.lastname);
		},

		_updateEmailAndUsername: (user, data) => {
			const newEmail = data.email.toLowerCase();

			if (newEmail !== user.getEmail()) {
				user.setEmail(newEmail);
			}

			if (newEmail !== user.getUsername()) {
				user.setUsername(newEmail);
			}
		},

		_updatePassword: (user, data) => {
			if (data.newPassword) {
				user.setPassword(data.newPassword);
			}
		},

		_updateStripeCustomer: (data) => {
			const currentUser = Portal.Current.user;
			if (!currentUser.stripeID) {
				return;
			}

			const stripePostData = {
				customerID: currentUser.stripeID,
				email: data.email.toLowerCase(),
			};

			if (
				Portal.Current.access.get("hasPremium") &&
				currentUser.subscriptionID
			) {
				stripePostData.subscriptionID = currentUser.subscriptionID;
			}

			Parse.Cloud.run("stripe-updateCustomer", stripePostData);
		},

		updateHomeSite: function (data, save) {
			if (!this.current()) return;

			const home = ObservingSite.createWithoutData(data.homeSite);

			if (data.homeSite) {
				this.current().set("homeSite", home);
			} else {
				this.current().set("homeSite", null);
			}

			if (save === true) {
				this.current().save();
			}
		},
		
		updatePrivacy: async function (data) {
			const currentUser = this.current();
			if (!currentUser) {
				return;
			}

			const privacyFields = ["shareName", "shareEmail", "shareHomeSite"];
			const privacyData = {};

			privacyFields.forEach((field) => {
				privacyData[field] = _.isUndefined(data[field]) ? false : data[field];
			});

			privacyFields.forEach((field) => {
				currentUser.set(field, privacyData[field]);
			});

			currentUser.setACL(new Parse.ACL(currentUser));

			try {
				await currentUser.save();
				Backbone.trigger("user:updated", "User Privacy Settings Updated");
			} catch (error) {
				Backbone.trigger("errors:parseReturned", error);
			}
		},
	},
);

export default User;
